import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpSendInvite} from '@/features/users/http/users.http.ts'

export const useSendInvite = (options?: UseMutationOptions<unknown, unknown, {userId: string}>) =>
    useMutation({mutationFn: urlParams => httpSendInvite({urlParams}), ...options})
